import type { DummyFoods } from './dummyFoods'

export const vinegar: DummyFoods = {
  Vinegar: {
    'Apple cider': ['Apple cider vinegar'],
    Balsamic: ['Balsamic vinegar'],
    'Red wine': ['Red wine vinegar'],
    'Rice wine': ['Rice wine vinegar'],
    'Sherry wine': ['Sherry wine vinegar'],
    White: ['White vinegar'],
    'White wine': ['White wine vinegar'],
  },
}
